import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';

@Injectable()
export class AuthService {
  private config = inject<AppConfig>(APP_CONFIG);
  private http = inject(HttpClient);


  logout(): Observable<any> {
    return this.http.post<any>(`${this.config.apiBaseUrl}/logout`, {});
  }
}
